import { render, staticRenderFns } from "./ApplicantBulkUpdate.vue?vue&type=template&id=2bf92130"
import script from "./ApplicantBulkUpdate.vue?vue&type=script&lang=js"
export * from "./ApplicantBulkUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports